import { AutoSaveIndicator, RouteTabWithContent, TabsWithContent } from "@homebound/beam";
import { useMemo } from "react";
import { useRouteParams } from "src/hooks/useRouteParams";
import { PageHeader } from "src/routes/layout/PageHeader";
import { ProjectParams } from "src/routes/routesDef";
import { createProjectSettingsUrl } from "src/RouteUrls";
import { projectSettingsRoute } from "src/routing/domains/projectsPaths";
import { useProjectContext } from "../context/ProjectContext";
import { CheckoutSettingsTab } from "./CheckoutSettingsTab";
import { HomeownersTab } from "./HomeownersTab";
import { OverallTab } from "./OverallTab";
import { ScheduleTab } from "./ScheduleTab";
import { SetUpTab } from "./SetUpTab";
import { TeamMembersTab } from "./TeamMembersTab";

export function ProjectSettingsPage() {
  const { projectId } = useRouteParams<ProjectParams>();
  const { __typename } = useProjectContext();

  const tabs: RouteTabWithContent[] = useMemo(
    () => [
      {
        name: "Overall",
        href: createProjectSettingsUrl(projectId),
        path: projectSettingsRoute.path,
        render: () => <OverallTab />,
      },
      {
        name: "Set Up",
        href: createProjectSettingsUrl(projectId, "setup"),
        path: `${projectSettingsRoute.path}/setup`,
        render: () => <SetUpTab />,
      },
      {
        name: "Team Members",
        href: createProjectSettingsUrl(projectId, "teamMembers"),
        path: `${projectSettingsRoute.path}/teamMembers`,
        render: () => <TeamMembersTab />,
      },
      {
        name: "Homeowner(s)",
        href: createProjectSettingsUrl(projectId, "homeowners"),
        path: `${projectSettingsRoute.path}/homeowners`,
        render: () => <HomeownersTab />,
      },
      {
        name: "Schedule",
        href: createProjectSettingsUrl(projectId, "schedule"),
        path: `${projectSettingsRoute.path}/schedule`,
        render: () => <ScheduleTab />,
      },
      ...(__typename === "Structure" || __typename === "Community" || __typename === "Lot"
        ? [
            {
              name: "Checkout",
              href: createProjectSettingsUrl(projectId, "checkoutSettings"),
              path: `${projectSettingsRoute.path}/checkoutSettings`,
              render: () => <CheckoutSettingsTab projectType={__typename} />,
            },
          ]
        : []),
    ],
    [projectId, __typename],
  );

  return (
    <>
      <PageHeader title="Project Settings" left={<AutoSaveIndicator />} />
      <TabsWithContent tabs={tabs} />
    </>
  );
}
